import React, { useContext, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/sidebar/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/navbar/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer";
import Settings from "../components/Settings";
import VideoCard from "../components/VideoCard";

import dashboardItems from "../components/sidebar/dashboardItems";
import { getCookie } from "../utils/cookies";
import { unescape } from "../utils/token";
import { useActions } from "../hooks/useActions";
import { getAllACVideos, getPublicVideos } from "../utils/apiService";
import { VideosContext } from "../contexts/VideosContext";
import VideoPlayModal from "../components/VideoPlayModal";
import CardPublic from "../components/CardPublic";
import { PublicVideoType, mockdataVideoType } from "../type/interface";
import heroImage from "../assets/img/photos/unsplash-1.jpg";
import "./styles.css";

// interface DashboardProps {
//   isToken: string;
//   setIsToken: Function;
// }

const Dashboard: React.FC = ({ children }) => {
  const { videos, setVideos } = useContext(VideosContext);
  // console.log("videos", videos);
  // const [isBtnOn, setIsBtnOn] = useState({
  //   isPublicOn: true,
  //   isSharingOn: true,
  //   isInternalOn: true,
  // });

  const [acVideos, setAcVideos] = useState([]);
  const [publicVideos, setPublicVideos] = useState<PublicVideoType[]>([]);
  const [acVideos2, setAcVideos2] = useState<mockdataVideoType[]>([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoURL, setVideoURL] = useState("");
  const [isAuth2nd, setIsAuth2nd] = useState({
    identity: "",
    sls: false,
    police: false,
    uts: false,
  });

  const publicApiCall = () => {
    getPublicVideos().then(
      (res) => {
        const data = res.data;
        setPublicVideos(data);
      },
      (err) => {
        console.log(err);
      }
    );
  };
  console.log("PublicVideos", publicVideos);
  const apiCall = (accessToken: string) => {
    console.log("acVideo api is getting called");
    getAllACVideos(!!accessToken).then(
      (response) => {
        // byagreement returns a bare array; older endpoints wrap in { videos: [] }.
        const videodata = Array.isArray(response.data)
          ? response.data
          : response.data?.videos ?? [];
        setAcVideos(videodata);
        setAcVideos2(videodata);
        setVideos(videodata);
        localStorage.setItem("videolist", JSON.stringify(videodata));
      },
      (error) => {
        console.log(error);
      }
    );
  };
  let oauth2TokenInitateValue = {
    uts: "",
    sls: "",
    police: "",
    ta: "",
  };
  const oauth2TokenOriginal = localStorage.getItem("oauth2Token2nd");
  let oauth2Token2nd = oauth2TokenOriginal && JSON.parse(oauth2TokenOriginal);
  if (!oauth2Token2nd) {
    oauth2Token2nd = oauth2TokenInitateValue;
  }
  const messageEvent = (e: any) => {
    if (typeof e.data !== "string") return;
    // The OAuth popup is served by cin-dsp-be on the tenant subdomain it ran on, so
    // the org is the first label of the message origin (dsp.localhost → "dsp").
    let org = "";
    try {
      org = new URL(e.origin).hostname.split(".")[0];
    } catch {
      return;
    }
    const processToken = JSON.parse(unescape(e.data));
    const bearerToken = processToken.token;
    const loginProfile = processToken.profile;

    if (org === "dsp") {
      // Primary DSP login — store the session, then reload so every component
      // re-reads it (the UI reads localStorage at render time, so a state
      // update alone doesn't flip the navbar/dashboard to logged-in).
      localStorage.setItem("user", JSON.stringify(loginProfile));
      localStorage.setItem("accessToken", bearerToken);
      window.location.reload();
    } else if (org) {
      // Per-provider 2nd-factor token for access-controlled video playback.
      (oauth2Token2nd as any)[org] = bearerToken;
      localStorage.setItem("oauth2Token2nd", JSON.stringify(oauth2Token2nd));
    }
  };
  const user = localStorage.getItem("user");

  useEffect(() => {
    // Always load the public list; load the access-controlled list whenever a
    // session exists (so it also loads after the post-login reload). The
    // message listener only handles tokens posted back by the OAuth popup.
    publicApiCall();
    const storedToken = localStorage.getItem("accessToken");
    if (storedToken) {
      apiCall(storedToken);
    }
    window.addEventListener("message", messageEvent, false);
    return () => window.removeEventListener("message", messageEvent);
  }, [user]);

  const { searchRepositories } = useActions();
  const oauthToken = getCookie("oauthToken");
  const accessToken = localStorage.getItem("accessToken");

  console.log("accessToken222", accessToken);

  // useEffect(() => {
  //   console.log("4444");
  //   //if accessToken exists, call the access control video api, if not exists means users hasn't login, call the public video API

  //   const timer = setTimeout(() => {
  //     apiCall();
  //   }, 1000);
  //   return () => clearTimeout(timer);
  // }, [accessToken]);

  useEffect(() => {
    // console.log("00000", acVideos2);
  }, [acVideos2]);

  // console.log("acVideos", acVideos);
  const UrlFunction = (url: string) => {
    setVideoURL(url);
  };
  const videoModalOpen = () => {
    setIsModalOpen(true);
  };

  useEffect(() => {
    if (user) {
      setIsAuth2nd({ ...isAuth2nd, identity: JSON.parse(user).organisation });
    }
  }, [user]);

  // console.log(isAuth2nd, "isAuth2nd");
  console.log("user", user);

  const UserLoginRender = () => {
    return (
      <div
        style={{
          display: "flex",
          // alignItems: "center",
          alignItems: "center",
          flexWrap: "wrap",
        }}
      >
        {acVideos2.map((eachVideo) => {
          return (
            <VideoCard
              data={eachVideo}
              key={eachVideo._id}
              setVideoURL={setVideoURL}
              setIsModalOpen={setIsModalOpen}
              videoModalOpen={videoModalOpen}
              UrlFunction={UrlFunction}
              setIsAuth2nd={setIsAuth2nd}
              isAuth2nd={isAuth2nd}
            />
          );
        })}
      </div>
    );
  };

  const PublicRender = () => {
    return (
      <div className="publiccontainer">
        <div className="publicleft">
          <img src={heroImage} alt="connectivity-pic" />
          <h1>CONNECTIVITY INNOVATION NETWORK</h1>
          <div className="publicLeftText">
            <h3>Our Vision </h3>
            <p>
              The vision of the Connectivity Innovation Network is to enhance
              Australia’s connectivity for Emergency & government services and
              communities, by leveraging academia, industry, and government
              expertise to drive technical innovation.
            </p>
          </div>
        </div>
        <div className="publicright">
          <h2>Latest public video information:</h2>
          {publicVideos.map((publicVideo: PublicVideoType) => (
            <CardPublic publicVideo={publicVideo} key={publicVideo._id} />
          ))}
        </div>
      </div>
    );
  };
  console.log("user", user);

  return (
    <React.Fragment>
      <Wrapper>
        <Sidebar items={dashboardItems} />
        <Main>
          <Navbar
            // isBtnOn={isBtnOn}
            // setIsBtnOn={setIsBtnOn}
            acVideos={acVideos}
            acVideos2={acVideos2}
            setAcVideos2={setAcVideos2}
          />

          <Content>
            {user ? UserLoginRender() : PublicRender()}
            <Outlet />
          </Content>
          <Footer />
        </Main>
      </Wrapper>
      <Settings />
    </React.Fragment>
  );
};

export default Dashboard;
